module.exports = __webpack_public_path__ + "img/city.734b31f.webp";